import { useEffect, useState } from 'react';
const keyCodeMap = {
    61: true,
    107: -100,
    109: +100,
    173: +100,
    187: -100,
    189: +100,
};
const useScale = () => {
    const [deltaY, setDeltaY] = useState(0);
    const wheelAction = e => {
        if (e.ctrlKey) {
            setDeltaY(e.deltaY + Math.random());
            e.preventDefault();
        }
    };
    const keydownAction = e => {
        const ctrlKey = e.ctrlKey || e.metaKey;
        if (ctrlKey && keyCodeMap[e.keyCode]) {
            setDeltaY(Math.random() + keyCodeMap[e.keyCode]);
            e.preventDefault();
        }
    };
    useEffect(() => {
        document.body.addEventListener('wheel', wheelAction, { passive: false });
        document.body.addEventListener('keydown', keydownAction, { passive: false });
        return () => {
            document.body.removeEventListener('wheel', wheelAction);
            document.body.removeEventListener('keydown', keydownAction);
        };
    }, []);
    return { deltaY };
};
export default useScale;
